// extracted by mini-css-extract-plugin
export default {"snackbar":"styles_snackbar__kjil9","snackbar__icon":"styles_snackbar__icon__So09A","snackbar__message":"styles_snackbar__message__WEnk5"};